import { useContext } from 'react'

import { OptimizelyContext } from '@optimizely/react-sdk'

import { useAuth } from 'routes/Menu/domains/auth'

export const useIsBlackFridayPromotion = (): boolean => {
  const { isAuthenticated } = useAuth()
  const { optimizely } = useContext(OptimizelyContext)

  const { enabled, variationKey } =
    optimizely && !isAuthenticated
      ? optimizely.decide('beetroots_ofx_black_friday_promo')
      : { enabled: false, variationKey: undefined }

  const isEnabled = enabled && variationKey === 'on'

  return isEnabled
}
